import { BrandModelType } from '@teinor/erp/types/company/product/brand'
import ModalCEBrand from './ModalCEBrand'
import { ComponentWithPermissions } from '../../../../../../baseComponents/CreateRoutering/types'
import TwinTable from '../../../../../../baseComponents/TwinTable'
import BaseScreenTable from '../../../../../../baseComponents/TwinTable/BaseScreenTable'
import { TableComponentProps } from '../../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import { DeleteRow, EditRowNotLink } from '../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { permissionCheck } from '../../../../../../baseComponents/PermissionChecker/function'
import ModalDeleteBrand from './ModalDeleteBrand'

interface BrandsProps extends ComponentWithPermissions { }

const Brands: React.FC<BrandsProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()
    const pageData = {
        title: t('Brands', 'Marcas'),
        newText: t('newBrand', 'Nueva marca')
    }

    return (
        <BaseScreenTable TableComponent={TableBrands} CreateModalComponent={ModalCEBrand} EditModalComponent={ModalCEBrand} DeleteModalComponent={ModalDeleteBrand} pageData={pageData} userPermissions={userPermissions} />
    )
}

interface TableBrandsProps extends TableComponentProps { }

const TableBrands: React.FC<TableBrandsProps> = ({userPermissions, setTableInstance, setOpened }) => {
    const { t } = useTwinTranslation()
    const columns: ColumnTableSchema<BrandModelType> = [
        {
            id: 'id',
            dataKey: 'id',
            label: t('id', 'ID'),
            sortable: true,
            width: 75
        },
        {
            id: 'name',
            dataKey: 'name',
            label: t('name', 'Nombre'),
            sortable: true,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('name', 'Nombre') }
            },
        },
        {
            id: 'edit',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('edit', 'Editar'),
            customRender: (parameterValue, allRowData) => <EditRowNotLink key={'edit' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'edit', allRowData })} />
        },
        {
            id: 'delete',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('delete', 'Eliminar'),
            customRender: (parameterValue, allRowData) => <DeleteRow key={'delete' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'delete', allRowData })} />,
            havePermission: permissionCheck(userPermissions, 'delete')
        }
    ]
    return (
        <TwinTable  columns={columns} name='brands' getDataFrom='/api/app/product/brand/getAllBrands' setTableInstance={setTableInstance} />
    )
}

export default Brands